<template>
  <hm-content title="">
    <div class="flex flex-start mb10">
      当前供货商: <span class="primary">{{ storeNames }}</span>
    </div>
    <div class="table-panel flex flex-between">
      <el-button type="primary" size="small" @click="addCategory"
        >新增类目</el-button
      >
      <div>
        <el-input
          clearable
          v-model.trim="keyWords"
          placeholder="输入分类名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <el-table
      @sort-change="sortChange"
      :data="goodsCategoryList.records"
      style="width: 100%"
      stripe
      size="small"
      border
      lazy
      row-key="categoryId"
      :load="load"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="left"
        label="类目名称"
        width="180"
        prop="categoryName"
      ></el-table-column>
      <!-- <el-table-column
        header-align="center"
        align="center"
        prop="categoryLogo"
        label="类目图标"
        width="180"
      >
        <template slot-scope="scope">
          <img style="width: 40px" :src="scope.row.categoryLogo" alt />
        </template>
      </el-table-column> -->
      <el-table-column
        header-align="center"
        align="center"
        prop="categoryLevel"
        label="级别"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="relationSpu"
        sortable
        label="商品数量"
      ></el-table-column>
      <!-- <el-table-column header-align="center" align="center" label="设置">
        <template slot-scope="scope">
          <el-button size="small" type="text" @click="moveTo(scope.row)"
            >查看商品</el-button
          >
        </template>
      </el-table-column> -->
      <el-table-column
        header-align="center"
        align="center"
        label="操作"
        width="200"
      >
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-tooltip class="item" content="添加子类目" placement="top">
              <div class="pointer mr10" @click="addChild(scope.row)">
                <span class="hmicon icon-tianjiaxiaji blue"></span>
              </div>
            </el-tooltip>
            <el-tooltip class="item" content="编辑" placement="top">
              <div class="pointer mr10" @click="edit(scope.row)">
                <span class="hmicon icon-bianji blue"></span>
              </div>
            </el-tooltip>
            <el-tooltip class="item" content="删除" placement="top">
              <div
                class="pointer"
                @click="remove(scope.row)"
                v-if="
                  !scope.row.isChild &&
                    scope.row.syncFlag === 'hemiao' &&
                    scope.row.relationSpu === 0
                "
              >
                <span class="hmicon icon-shanchu primary"></span>
              </div>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="类目层级">
          <el-radio-group
            v-model="ruleForm.level"
            :disabled="mode === 'addChild'"
            @change="switchLevel"
          >
            <el-radio label="parent">一级类目</el-radio>
            <el-radio label="child">子类目</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="类目名称" prop="categoryName">
          <el-input
            v-model.trim="ruleForm.categoryName"
            maxlength="20"
            size="small"
            placeholder="请输入单行文本，限制20个字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="上级类目" v-if="ruleForm.level === 'child'">
          <el-cascader
            v-if="mode !== 'addChild'"
            ref="cascader"
            v-model="ruleForm.categoryId"
            :disabled="ruleForm.level === 'parent'"
            :props="props"
            :show-all-levels="false"
            size="small"
          ></el-cascader>
          <el-input
            v-if="mode === 'addChild'"
            :value="currentRow.categoryName"
            size="small"
            type="text"
            disabled
          />
        </el-form-item>
        <!-- <el-form-item label="类目图标">
          <div class="flex upload-upload-btn" @click="show = true">
            <div
              class="btn flex flex-column flex-center open-file"
              v-if="!ruleForm.categoryLogo"
            >
              <div class="add-wrapper">
                <span class="hmicon icon-hao pointer"></span>
              </div>
              <span>添加图片</span>
            </div>
            <div v-if="ruleForm.categoryLogo" class="mr10 flex item-end">
              <img class="logo" :src="ruleForm.categoryLogo" alt="logo" />
            </div>
            <div class="flex flex-column flex-end">
              <div class="tips">只能上传jpg/png文件，且不能超过1MB</div>
              <div class="tips">建议图片尺寸为400x400px(最多上传一张）</div>
            </div>
          </div>
        </el-form-item> -->
      </el-form>
      <!-- <my-upload
        field="file"
        @crop-upload-success="cropUploadSuccess"
        v-model="show"
        noCircle
        noSquare
        :width="400"
        :height="400"
        :headers="{ 'X-Access-Token': $token }"
        :params="{ fileDir: 'goodsCenter' }"
        :url="$uploadUrl"
        img-format="png"
      ></my-upload> -->
      <div class="btn-wrapper flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="save"
          :disabled="!ruleForm.categoryId.length && ruleForm.level === 'child'"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
// import { setCookie, getCookie } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      ruleForm: {
        categoryId: [],
        level: "parent",
        categoryLogo: "",
        categoryName: ""
      },
      rules: {
        categoryName: {
          required: true,
          trrger: "blur",
          message: "请输入类目名"
        }
      },
      show: false,
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1,
                curCategoryId:
                  this.mode === "add" ? "" : this.currentRow.categoryId,
                storeCode: this.$route.query.storeCode
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId,
                storeCode: this.$route.query.storeCode
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      title: "",
      mode: "add",
      keyWords: "",
      sort: {},
      level: 0,
      parentCategoryId: "",
      parentCategoryName: "",
      dialogVisible: false,
      categoryName: "",
      currentRow: {},
      tableData1: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      categoryId: "",
      categoryLevel: "",
      no: 1,
      storeNames: "",
      storeCode: this.$route.query.storeCode
    };
  },
  computed: mapGetters(["goodsCategoryList"]),
  watch: {
    "goodsCategoryList.total": {
      handler(val) {
        if (
          val == (this.currentPage - 1) * this.pageSize &&
          this.pageTotal != 0
        ) {
          this.currentPage -= 1;
          this.queryList();
        }
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.storeNames = localStorage.getItem("storeName");
    this.queryList();
  },
  methods: {
    sortChange(sort) {
      this.sort = sort;
      this.queryList();
    },
    moveTo(row) {
      this.$router.push({
        name: "GoodsList",
        query: {
          categoryId: row.categoryId
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    switchLevel() {
      this.ruleForm.categoryId = [];
    },
    async queryList() {
      const { result } = await this.$store.dispatch("queryGoodsCategoryList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        keyWords: this.keyWords,
        order: this.sort.order,
        prop: this.sort.prop,
        storeCode: this.$route.query.storeCode
      });
      this.list = result.records;
    },

    cropUploadSuccess(jsonData) {
      this.ruleForm.categoryLogo = jsonData.result;
    },
    addCategory() {
      this.mode = "add";
      this.title = "新增类目";
      this.dialogVisible = true;
      this.ruleForm.level = "parent";
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    addChild(row) {
      this.mode = "addChild";
      this.title = "新增子类目";
      this.currentRow = row;
      this.dialogVisible = true;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
      this.ruleForm.level = "child";
      this.ruleForm.categoryId = [this.currentRow.categoryId];
      this.level = +this.currentRow.categoryLevel + 1;
    },
    edit(row) {
      this.mode = "edit";
      this.title = "编辑类目";
      this.currentRow = row;
      this.dialogVisible = true;
      this.ruleForm.level = "parent";
      this.$store
        .dispatch("queryGoodsCategoryDetails", {
          categoryId: this.currentRow.categoryId,
          storeCode: this.$route.query.storeCode
        })
        .then(res => {
          this.ruleForm.level =
            +this.currentRow.categoryLevel > 1 ? "child" : "parent";
          this.ruleForm.categoryName = this.currentRow.categoryName;
          this.ruleForm.categoryLogo = this.currentRow.categoryLogo;
          this.ruleForm.categoryId = [res.result.parentCategoryId];
          this.parentCategoryName = res.result.parentCategoryName || "-";
          setTimeout(() => {
            if (this.$refs.cascader) {
              this.$refs.cascader.inputValue = this.parentCategoryName;
            }
          }, 0);
        });
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.parentCategoryName = "";
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("deleteGoodsCategory", {
            categoryId: row.categoryId,
            storeCode: this.$route.query.storeCode
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.$store.commit("QUERY_GOOD_CATEGORY_LIST", {
                result: { record: [] }
              });
              this.queryList();
            }
          });
      });
    },
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // const categoryLevel =
          //   this.ruleForm.level === "parent" ? "1" : this.level;
          let parentCategoryId = this.ruleForm.categoryId[
            this.ruleForm.categoryId.length - 1
          ];

          let params = {
            // categoryLevel,
            categoryLogo: this.ruleForm.categoryLogo,
            categoryName: this.ruleForm.categoryName,
            parentCategoryId
          };
          let actionName = "";
          if (this.mode === "add" || this.mode === "addChild") {
            actionName = "addGoodsCategory";
            if (this.ruleForm.level === "parent") {
              params.parentCategoryId = "";
            }
          } else if (this.mode === "edit") {
            if (this.ruleForm.level === "parent") {
              params.parentCategoryId = "-";
            }
            params = Object.assign(params, {
              categoryId: this.currentRow.categoryId
            });
            actionName = "editGoodsCategory";
          }

          params.storeCode = this.$route.query.storeCode;
          this.$store.dispatch(actionName, params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.dialogVisible = false;

              this.$store.commit("QUERY_GOOD_CATEGORY_LIST", {
                result: { record: [] }
              });
              this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    load(tree, treeNode, resolve) {
      this.categoryId = tree.categoryId;
      this.categoryLevel = tree.categoryLevel;
      const { categoryLevel, categoryId } = tree;
      resolve([]);
      // if (this.no === 1) {
      this.$store
        .dispatch("queryGoodsCategoryListByParent", {
          parentCategoryId: categoryId,
          categoryLevel: +categoryLevel + 1,
          pageNo: 1,
          pageSize: 999,
          storeCode: this.$route.query.storeCode
        })
        .then(res => {
          if (res.code === "0" && res.result.records.length) {
            res.result.records.forEach(v => {
              v.hasChildren = Boolean(v.isChild);
            });
            resolve(res.result.records);
          } else {
            resolve([]);
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped></style>
